import React from 'react';

export const BulletListFormatter = (bulletPoints: string[]) => {
  if (!Array.isArray(bulletPoints) || bulletPoints.length === 0) return null;

  return (
    <ul
      style={{
        listStyleType: 'disc',
        listStylePosition: 'outside',
        paddingLeft: '1.25rem',
        margin: '6px 0',
      }}
    >
      {bulletPoints.map((point, index) => (
        <li key={index} style={{ marginBottom: 4 }}>
          {point}
        </li>
      ))}
    </ul>
  );
};
